import {createRouter, createWebHistory} from "vue-router";
import {orderStore} from "@/store";

import OrderAuth from "@/components/OrderAuth";
import OrderMain from "@/components/OrderMain";
import AlbumUpload from "@/components/AlbumUpload";
import ItemUpload from "@/components/ItemUpload";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            meta: {title: '认证'},
            path: '/',
            component: OrderAuth,
        },
        {
            meta: {title: '列表'},
            path: '/main',
            component: OrderMain
        },
        {
            meta: {title: '数据组'},
            path: '/album',
            component: AlbumUpload
        },
        {
            meta: {title: '上传数据'},
            path: '/item',
            component: ItemUpload
        },
    ]
})


// 使用路由守卫
router.beforeEach(async (to, from, next) => {
    document.title = 'UP！UP！'
    // console.log('router changed', from.path, '->', to.path)
    if (to.path === '/') {
        next()
    } else {
        const store = orderStore()
        try {
            // 获取一次当前订单信息
            await store.getOrderInfo()
            console.debug('[Router]', 'Check Order Info Passed')
            // 放行到下一个页面
            next()
        } catch (e) {
            console.error('[Router]', 'Check Order Info Catch', e)
            // 发生错误的时候, 清空token
            store.removeToken()
            // 跳转到登录
            // next(`/login?redirect=${to.path}`)
            next('/')
        }
    }
})


export default router;